<template>
    <div
        :container="name"
        :type="type"
        :state="state"
        :flag="flag"
        :align="align"
        :valign="valign"
        :block-width="blockWidth"
        :block-height="blockHeight"
        :padding="padding"
        :margin="margin"
    >
        <!--		<container-setup  @setType="setType" v-if="state == 'edit'">-->
        <!--			<template v-slot:align="props">-->
        <!--				<div class="icon" @click="setAttr" attr="align" value="left" :selected="align == 'left'">format_align_left</div>-->
        <!--				<div class="icon" @click="setAttr" attr="align" value="center" :selected="align == 'center'">format_align_center</div>-->
        <!--				<div class="icon" @click="setAttr" attr="align" value="right" :selected="align == 'right'">format_align_right</div>-->
        <!--				<div class="icon" @click="setAttr" attr="align" value="space" :selected="align == 'space'">format_align_justify</div>-->
        <!--			</template>-->
        <!--			<template v-slot:valign>-->
        <!--				<div class="icon" @click="setAttr" attr="valign" value="top" :selected="valign == 'top'">format_align_left</div>-->
        <!--				<div class="icon" @click="setAttr" attr="valign" value="center" :selected="valign == 'center'">format_align_center</div>-->
        <!--				<div class="icon" @click="setAttr" attr="valign" value="bottom" :selected="valign == 'bottom'">format_align_right</div>-->
        <!--				<div class="icon" @click="setAttr" attr="valign" value="stretch" :selected="valign == 'stretch'">format_align_justify</div>-->
        <!--			</template>-->
        <!--			<template v-slot:horizontal>-->
        <!--				<div class="tool">tool - 1</div>-->
        <!--				<div class="tool">tool - 2</div>-->
        <!--				<div class="tool">tool - 3</div>-->
        <!--			</template>-->
        <!--			<template v-slot:vertical>-->
        <!--				<div class="tool">tool - 1</div>-->
        <!--				<div class="tool">tool - 2</div>-->
        <!--			</template>-->
        <!--			<template v-slot:tiles>-->
        <!--				<div class="tool">-->
        <!--					počet: -->
        <!--					<select>-->
        <!--						<option value="1">1</option>-->
        <!--						<option value="12">2</option>-->
        <!--						<option value="13">3</option>-->
        <!--						<option value="14">4</option>-->
        <!--						<option value="15">5</option>-->
        <!--						<option value="16">6</option>-->
        <!--						<option value="17">7</option>-->
        <!--						<option value="18">8</option>-->
        <!--					</select>-->
        <!--				</div>-->
        <!--			</template>-->
        <!--			<template v-slot:templates>-->
        <!--				<h3>- Kuk - </h3>-->
        <!--			</template>-->
        <!--		</container-setup>-->

        <slot></slot>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import ContainerSetup from '@/mock/ContainerSetup.vue';
//import Velocity from 'velocity-animate';

export default {
    name: 'Container',

    props: {
        name: {
            type: String,
            required: true,
        },

        type: {
            type: String,
            required: true,
        },

        state: {
            type: String,
            required: false,
        },

        flag: {
            type: String,
            required: false,
        },

        align: {
            type: String,
            required: false,
        },

        valign: {
            type: String,
            required: false,
        },

        blockWidth: {
            type: String,
            required: false,
        },

        blockHeight: {
            type: String,
            required: false,
        },

        padding: {
            type: String,
            required: false,
        },

        margin: {
            type: String,
            required: false,
        },
    },

    computed: {},

    data() {
        return {};
    },

    methods: {
        setType(type) {
            // this.type = type;
        },

        setAttr(event) {
            const attr = event.target.getAttribute('attr');
            const value = event.target.getAttribute('value');

            this[attr] = value;
        },

        open(item) {
            var openPanel = item.target.parentElement.parentElement;
            const width = 40 + parseInt(item.target.nextElementSibling.clientWidth);

            openPanel.style.width = width + 'px';
            this.$refs.accordion.querySelector('[open]').style.width = '40px';

            this.openItem = item.target.getAttribute('for');
            const emit = item.target.getAttribute('emit') ? true : false;

            if (emit) this.$emit('setType', this.openItem);
        },
    },

    components: {
        // ContainerSetup
    },
};
</script>

<style lang="less">
@import '~@variables';

// STAVY

[container][state='edit'] {
    // padding-top: 60px !important;

    > [block] {
        display: block !important;
        border: 2px dotted black;
        // margin: -2px 0 0 -2px;
        // padding: 2px 0 0 2px;
    }
}

// TAGY

[container][tag='unfulfilled'] {
}

[container] {
    transition: 0.5s ease;
    display: flex;
    position: relative;

    // .item{
    // 	margin-right: 1px;
    // }

    .tool {
        min-width: 40px;
        white-space: nowrap;
        height: 40px;
        .flex-center;

        select {
            margin: 0 10px 0 5px;
            padding: 0 10px;
            width: 40px;
            background-color: fade(white, 25%);
        }
    }

    // .icon{
    // 	height: 40px;
    // 	width: 40px;
    // 	min-width: 40px;
    // 	background-color: @grey_lt;
    // 	.flex-center;
    // 	cursor: pointer;
    // 	transition: 0.3s;

    // 	&:hover{
    // 		background-color: @grey;
    // 	}

    // 	&[selected]{
    // 		background-color: @grey_dk !important;
    // 	}

    // 	&[attr="valign"]{
    // 		transform: rotate(90deg);
    // 	}
    // }

    &[wrap='true'] {
        flex-wrap: wrap;
    }

    // PADDINGS ------------------------------------

    &[padding] {
    }

    &[padding='none'] {
        padding: 0px;
    }

    &[padding='xsmall'] {
        padding: 5px;
    }

    &[padding='small'] {
        padding: 10px;
    }

    &[padding='medium'] {
        padding: 15px;
    }

    &[padding='large'] {
        padding: 30px;
    }

    &[padding='xlarge'] {
        padding: 60px;
    }

    &[padding='xxlarge'] {
        padding: 90px;
    }

    // CELL PADDINGS ------------------------------------

    &[block-padding] {
        [block] {
        }
    }

    &[block-padding='none'] {
        [block] {
            padding: 0px;
        }
    }

    &[block-padding='xsmall'] {
        [block] {
            padding: 5px;
        }
    }

    &[block-padding='small'] {
        [block] {
            padding: 10px;
        }
    }

    &[block-padding='medium'] {
        [block] {
            padding: 15px;
        }
    }

    &[block-padding='large'] {
        [block] {
            padding: 30px;
        }
    }

    &[block-padding='xlarge'] {
        [block] {
            padding: 60px;
        }
    }

    &[block-padding='xxlarge'] {
        [block] {
            padding: 90px;
        }
    }

    // MARGINS ------------------------------------

    &[margin] {
    }

    &[margin='none'] {
        margin: 0px;
    }

    &[margin='xsmall'] {
        margin: 5px;
    }

    &[margin='small'] {
        margin: 10px;
    }

    &[margin='medium'] {
        margin: 15px;
    }

    &[margin='large'] {
        margin: 30px;
    }

    &[margin='xlarge'] {
        margin: 60px;
    }

    &[margin='xxlarge'] {
        margin: 90px;
    }

    // BLOCK WIDTH ------------------------------------

    &[block-width] {
        > [block] {
            width: initial;
            width: unset;
            width: auto;
        }
    }

    &[block-width='1'] {
        > [block] {
            width: 100%;
        }
    }

    &[block-width='12'] {
        > [block] {
            width: 50%;
        }
    }

    &[block-width='13'] {
        > [block] {
            width: 33.33%;
        }
    }

    &[block-width='23'] {
        > [block] {
            width: 66.66%;
        }
    }

    &[block-width='14'] {
        > [block] {
            width: 25%;
        }
    }

    &[block-width='24'] {
        > [block] {
            width: 50%;
        }
    }

    &[block-width='34'] {
        > [block] {
            width: 75%;
        }
    }

    &[block-width='15'] {
        > [block] {
            width: 20%;
        }
    }

    &[block-width='25'] {
        > [block] {
            width: 40%;
        }
    }

    &[block-width='35'] {
        > [block] {
            width: 60%;
        }
    }

    &[block-width='45'] {
        > [block] {
            width: 80%;
        }
    }

    &[block-width='stretch'] {
        > [block] {
            flex: 1;
        }
    }

    // BLOCK HEIGHT ------------------------------------

    &[block-height] {
    }

    &[block-height='1'] {
        > [block] {
            height: 100%;
        }
    }

    &[block-height='12'] {
        > [block] {
            height: 50%;
        }
    }

    &[block-height='13'] {
        > [block] {
            height: 33.33%;
        }
    }

    &[block-height='14'] {
        > [block] {
            height: 25%;
        }
    }

    &[block-height='15'] {
        > [block] {
            height: 20%;
        }
    }

    &[block-height='stretch'] {
        > [block] {
            flex: 1;
        }
    }

    // WIDTH ------------------------------------

    &[width] {
        width: initial;
        width: unset;
        width: auto;
    }

    &[width='1'] {
        width: 100%;
    }

    &[width='12'] {
        width: 50%;
    }

    &[width='13'] {
        width: 33.33%;
    }

    &[width='23'] {
        width: 66.66%;
    }

    &[width='14'] {
        width: 25%;
    }

    &[width='24'] {
        width: 50%;
    }

    &[width='34'] {
        width: 75%;
    }

    &[width='15'] {
        width: 20%;
    }

    &[width='25'] {
        width: 40%;
    }

    &[width='35'] {
        width: 60%;
    }

    &[width='45'] {
        width: 80%;
    }

    // TYPE TILES & TEMPLATE ------------------------------------

    &[type='tiles'],
    &[type='template'] {
        flex-wrap: wrap;
    }

    // TYPE VERTICAL & TILES ------------------------------------

    &[type='horizontal'],
    &[type='tiles'],
    &[type='template'] {
        flex-direction: row;

        &[align='left'] {
            justify-content: flex-start;
        }

        &[align='center'] {
            justify-content: center;
        }

        &[align='right'] {
            justify-content: flex-end;
        }

        &[align='space'] {
            justify-content: space-between;
        }

        //-------------------------------------

        &[valign='top'] {
            align-items: flex-start;
        }

        &[valign='center'] {
            align-items: center;
        }

        &[valign='bottom'] {
            align-items: flex-end;
        }

        &[valign='stretch'] {
            align-items: stretch;
        }
    }

    // TYPE VERTICAL ------------------------------------

    &[type='vertical'] {
        flex-direction: column;

        &[align='left'] {
            align-items: flex-start;
        }

        &[align='center'] {
            align-items: center;
        }

        &[align='right'] {
            align-items: flex-end;
        }

        &[valign='top'] {
            justify-content: flex-start;
        }

        &[valign='center'] {
            justify-content: center;
        }

        &[valign='bottom'] {
            justify-content: flex-end;
        }
    }
}
</style>
